import { StyleSheet } from 'react-native';
import { colors, sizes, defaultShadow } from '~/values';

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFF',
    borderRadius: 0,
    flexDirection: 'row',
    paddingHorizontal: sizes.horizontalSpace,
    paddingVertical: sizes.verticalSpaceSeparatorNormal,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  infoContainer: {
    flex: 1,
    padding: 16,
  },
  nameLikeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    justifyContent: 'space-between',
  },
  name: {
    color: colors.grayDark,
    fontSize: 16,
    fontWeight: '600',
    marginRight: 6,
    flex: 1,
  },
  total: {
    fontSize: 14,
    color: colors.grayMid,
  },
});

export default styles;
